var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.55025 2.05025C5.28392 -0.683417 9.71608 -0.683418 12.4497 2.05025C15.1834 4.78392 15.1834 9.21608 12.4497 11.9497L7.5 16.8995L2.55025 11.9497C-0.183418 9.21608 -0.183418 4.78392 2.55025 2.05025ZM7.5 9C8.60457 9 9.5 8.10457 9.5 7C9.5 5.89543 8.60457 5 7.5 5C6.39543 5 5.5 5.89543 5.5 7C5.5 8.10457 6.39543 9 7.5 9Z",
    fill: "#DC6803"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoc);
export default __webpack_public_path__ + "static/media/loc.62f7e20d2a2f2043b9dccbe7c87c7d67.svg";
export { ForwardRef as ReactComponent };